"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCost = addCost;
exports.addTranching = addTranching;
exports.allmerchantList = allmerchantList;
exports.delCost = delCost;
exports.delTranching = delTranching;
exports.getCostDetail = getCostDetail;
exports.getCostList = getCostList;
exports.getcardList = getcardList;
exports.gettranchingList = gettranchingList;
exports.gettranchingListDetail = gettranchingListDetail;
exports.merchantList = merchantList;
exports.updateCostConfig = updateCostConfig;
exports.updateCostStatus = updateCostStatus;
exports.updateTranching = updateTranching;
exports.updateTranchingStatus = updateTranchingStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 成本配置保存请求参数
 * @typedef {Object} ConfigCostSaveRequest
 * @property {number} accountPeriodDays - 账期天数
 * @property {number} accountThreshold - 账期金额阈值（元）
 * @property {number} id - 成本ID，编辑时必填
 * @property {number} mailBasicProfit - 商城基本利润比例（%）
 * @property {Array<MerchantCost>} merchantCostList - 商户成本配置列表
 * @property {number} otherFee - 其他费用比例（%）
 * @property {number} platformServiceFee - 平台服务费比例（%）
 * @property {number} productOperationFee - 商品运营费比例（%）
 */

/**
 * 商户成本配置
 * @typedef {Object} MerchantCost
 * @property {number} id - 商户ID
 * @property {boolean} isSwitch - 商户开关：0-关闭，1-开启
 * @property {string} merchantCategory - 店铺类型
 * @property {string} merchantType - 商户类型
 * @property {string} name - 商户名称
 * @property {string} phone - 商户手机号
 * @property {string} realName - 商户姓名
 */
function addCost(data) {
  return (0, _request.default)({
    url: '/admin/platform/config/cost/add',
    method: 'POST',
    data: data
  });
}

/**
 * 删除
 * @param
 */
function delCost(id) {
  return (0, _request.default)({
    url: "/admin/platform/config/cost/delete/".concat(id),
    method: 'DELETE'
  });
}

/**
 * 详情
 * @param
 */
function getCostDetail(pram) {
  return (0, _request.default)({
    url: "/admin/platform/config/cost/info/".concat(pram),
    method: 'GET'
  });
}

/**
 * 成本配置查询参数
 * @typedef {Object} ConfigCostQueryParams
 * @property {number} [accountPeriodDaysEnd] - 账期天数上限
 * @property {number} [accountPeriodDaysStart] - 账期天数下限
 * @property {number} [accountThresholdEnd] - 账期金额上限
 * @property {number} [accountThresholdStart] - 账期金额下限
 * @property {number} [limit] - 每页数量
 * @property {number} [mailBasicProfitEnd] - 商城基本利润上限
 * @property {number} [mailBasicProfitStart] - 商城基本利润下限
 * @property {string} [merchantName] - 商户名称，支持模糊查询
 * @property {number} [otherFeeEnd] - 其他费用上限
 * @property {number} [otherFeeStart] - 其他费用下限
 * @property {number} [page] - 页码
 * @property {number} [platformServiceFeeEnd] - 平台服务费上限
 * @property {number} [platformServiceFeeStart] - 平台服务费下限
 * @property {number} [productOperationFeeEnd] - 商品运营费上限
 * @property {number} [productOperationFeeStart] - 商品运营费下限
 * @property {number} [status] - 生效状态
 */

/**
 * 成本配置响应数据
 * @typedef {Object} ConfigCostResponse
 * @property {number} limit - 每页数量
 * @property {Array<ConfigCostItem>} list - 成本配置列表
 * @property {number} page - 当前页码
 * @property {number} total - 总记录数
 * @property {number} totalPage - 总页数
 */

/**
 * 成本配置项
 * @typedef {Object} ConfigCostItem
 * @property {number} accountPeriodDays - 账期天数
 * @property {number} accountThreshold - 账期金额阈值（元）
 * @property {string} createTime - 创建时间
 * @property {number} id - 成本ID
 * @property {number} mailBasicProfit - 商城基本利润比例（%）
 * @property {string} merchantName - 适配商户
 * @property {number} otherFee - 其他费用比例（%）
 * @property {number} platformServiceFee - 平台服务费比例（%）
 * @property {number} productOperationFee - 商品运营费比例（%）
 * @property {number} status - 生效状态（1=生效，0=失效）
 * @property {string} updateTime - 更新时间
 */
function getCostList(params) {
  return (0, _request.default)({
    url: '/admin/platform/config/cost/page/list',
    method: 'get',
    params: params
  });
}

/**
 * 成本配置保存请求参数
 * @typedef {Object} ConfigCostSaveRequest
 * @property {number} accountPeriodDays - 账期天数
 * @property {number} accountThreshold - 账期金额阈值（元）
 * @property {number} id - 成本ID，编辑时必填
 * @property {number} mailBasicProfit - 商城基本利润比例（%）
 * @property {Array<MerchantCost>} merchantCostList - 商户成本配置列表
 * @property {number} otherFee - 其他费用比例（%）
 * @property {number} platformServiceFee - 平台服务费比例（%）
 * @property {number} productOperationFee - 商品运营费比例（%）
 */

/**
 * 商户成本配置
 * @typedef {Object} MerchantCost
 * @property {number} id - 商户ID
 * @property {boolean} isSwitch - 商户开关：0-关闭，1-开启
 * @property {string} merchantCategory - 店铺类型
 * @property {string} merchantType - 商户类型
 * @property {string} name - 商户名称
 * @property {string} phone - 商户手机号
 * @property {string} realName - 商户姓名
 */
function updateCostConfig(data) {
  return (0, _request.default)({
    url: '/admin/platform/config/cost/update',
    method: 'PUT',
    data: data
  });
}

/**
 * 修改身份状态
 * @param
 */
function updateCostStatus(data) {
  return (0, _request.default)({
    url: '/admin/platform/config/cost/update/status',
    method: 'PUT',
    data: data
  });
}

/**
 * 缓存菜单
 * @param
 */
function merchantList(id) {
  var params = {
    id: id,
    limit: 1000,
    page: 1
  };
  return (0, _request.default)({
    url: '/admin/platform/config/cost/info/merchant/list',
    method: 'get',
    params: params
  });
}
/**
 * 商户列表
 * @param
 */
function allmerchantList(params) {
  return (0, _request.default)({
    url: '/admin/platform/merchant/cost/list',
    method: 'get',
    params: params
  });
}
/**
 * 分页查询分档配置列表
 * @param
 */
function gettranchingList(params) {
  return (0, _request.default)({
    url: '/admin/platform/config/tranching/page/list',
    method: 'get',
    params: params
  });
}
/**
 * 分页查询分档配置列表详情
 * @param
 */
function gettranchingListDetail(id) {
  return (0, _request.default)({
    url: "/admin/platform/config/tranching/info/".concat(id),
    method: 'get'
  });
}
/**
 * 查询分档配置会员卡列表
 * @param
 */
function getcardList() {
  return (0, _request.default)({
    url: "/admin/platform/merchant/card/list",
    method: 'get'
  });
}
/**
* 保存分档配置
* @param
*/
function addTranching(params) {
  return (0, _request.default)({
    url: "/admin/platform/config/tranching/add",
    method: 'post',
    data: params
  });
}
/**
* 修改分档配置
* @param
*/
function updateTranching(params) {
  return (0, _request.default)({
    url: "/admin/platform/config/tranching/update",
    method: 'put',
    data: params
  });
}
/**
* 修改分档配置状态
* @param
*/
function updateTranchingStatus(params) {
  return (0, _request.default)({
    url: "/admin/platform/config/tranching/update/status",
    method: 'put',
    data: params
  });
}
/**
* 删除分档配置
* @param
*/
function delTranching(id) {
  return (0, _request.default)({
    url: "/admin/platform/config/tranching/delete/".concat(id),
    method: 'delete'
  });
}